module.exports = __webpack_public_path__ + "img/two.28ca0edf.png";